/**
 * Splitter — one-to-many junction.
 * Equal pressure at all outlets, same enthalpy, mass conservation.
 */
import type { NSComponent, Junction, ComponentUpdate } from '../types';

export class NSSplitter implements NSComponent {
  id: string;
  type = 'splitter';
  params: Record<string, any>;

  constructor(id: string, params: { split_fraction?: number }) {
    this.id = id;
    this.params = { split_fraction: 0.5, ...params };
  }

  applyBoundaryConditions(inlet: Junction, _outlet: Junction, _dt: number): ComponentUpdate {
    // Splitter: no pressure drop, no enthalpy change — every branch leaves at the
    // inlet enthalpy. Flow distribution is handled by junction mass balance +
    // downstream resistance; enthalpy propagation is handled by nsNetwork Step 4
    // (R2-B3), which republishes the junction's enthalpy onto every outflow cell
    // even though deltaH === 0 here, so each split branch carries the inlet state
    // downstream instead of freezing at its initial value.
    return {
      deltaP: 0,
      deltaH: 0,
      momentumSource: 0,
      energySource: 0,
      metadata: { split_fraction: this.params.split_fraction },
    };
  }
}
